import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserPlus, Loader2 } from 'lucide-react';
import { Logo } from '../shell/Logo';
import { register } from '../api/authApi';
import { ApiError } from '../api/client';

export default function RegisterPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await register({ email, password, name });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '회원가입에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-form">
          <div className="auth-form__brand">
            <Logo size={20} showText={false} />
            <span className="auth-form__brand-name">Alpha Omega Quant</span>
          </div>
          <h1>가입 요청이 접수되었습니다</h1>
          <p>{email} 로 인증 메일이 발송되었습니다. 메일의 링크를 클릭해 인증을 완료해주세요.</p>
          <Link to="/login">로그인으로</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-form__brand">
          <Logo size={20} showText={false} />
          <span className="auth-form__brand-name">Alpha Omega Quant</span>
        </div>
        <h1>회원가입</h1>
        <label>
          <span>이름</span>
          <input value={name} onChange={(e) => setName(e.target.value)} required maxLength={64} />
        </label>
        <label>
          <span>이메일</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>
          <span>비밀번호 (8자 이상)</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
        </label>
        {error && <div className="auth-error" role="alert">{error}</div>}
        <button type="submit" disabled={submitting}>
          {submitting ? (
            <Loader2 size={16} strokeWidth={1.75} className="pca-spin" />
          ) : (
            <UserPlus size={16} strokeWidth={1.75} />
          )}
          {submitting ? '가입 요청 중...' : '가입하기'}
        </button>
        <div className="auth-links">
          <Link to="/login">이미 계정이 있습니다</Link>
        </div>
      </form>
    </div>
  );
}
